var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSweetOrHotBgClipedLeft = function SvgSweetOrHotBgClipedLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M36.484 8.671C32.878 3.434 26.84 0 20 0 8.954 0 0 8.954 0 20s8.954 20 20 20c6.84 0 12.878-3.434 16.484-8.671A26.899 26.899 0 0 1 34 20a26.9 26.9 0 0 1 2.484-11.329Z",
    clipRule: "evenodd"
  })));
};
export default SvgSweetOrHotBgClipedLeft;